import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "carousel-slides-wrp w-100",
  ref: "slidesWrp"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left control-handler" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-right control-handler" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isFirstStep && _ctx.showHandlers)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "carousel-slides-wrp__control-arrow lx-arrow",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.prevSlide && _ctx.prevSlide(...args)))
        }, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "carouselItems"),
    (!_ctx.isLastStep && _ctx.showHandlers)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: "carousel-slides-wrp__control-arrow rx-arrow",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextSlide && _ctx.nextSlide(...args)))
        }, [
          _hoisted_3
        ]))
      : _createCommentVNode("", true)
  ], 512))
}